module.exports = __webpack_public_path__ + "img/drawer.0453558c.svg";